import Spinner from 'react-bootstrap/Spinner'
import { useEffect, useState } from 'react'

const CustomSpinner = () => {
  const [showSpinner, setShowSpinner] = useState(false)

  // only show the spinner after some time
  useEffect(() => {
    let mounted = true
    const internal = setTimeout(() => {
      if (mounted) {
        setShowSpinner(true)
      }
    }, 700)

    return () => {
      mounted = false
      clearInterval(internal)
    }
  }, [])

  if (!showSpinner) return <div />

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <Spinner animation="border" />
    </div>
  )
}

export default CustomSpinner
